import { Resident } from './../../models/resident.model';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
('@angular/material/button');
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CartProduct, DeletedProducts } from '../../models/cart.model';
import { ModalCloseButtonComponent } from '../modal-close-button/modal-close-button.component';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  imports: [
    MatDialogModule,
    MatIconModule,
    CommonModule,
    ModalCloseButtonComponent,
  ],
})
export class InfoModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      residentInactive?: boolean;
      products?: DeletedProducts[];
      buttons?: {
        text: string;
        id: number;
        color: string;
        action?: () => void;
        closeDialog?: boolean;
      }[];
    },
    private dialogRef: MatDialogRef<InfoModalComponent>
  ) {}

  displayProduct(product: { product: CartProduct; resident: Resident }) {
    return `${product.product.brand} ${product.product.name}&nbsp;&nbsp;|&nbsp;&nbsp;${product.product.quantity} Stk&nbsp;&nbsp;|&nbsp;&nbsp;${product.resident.fname} ${product.resident.lname}`;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  performAction(id: number) {
    this.data.buttons[id].action();
    this.closeDialog();
  }
}
